import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { isMobile } from 'react-device-detect';
import ThemeContext from '../../providers/ThemeProvider';

const WelcomeText = ({ extraClasses, isLoggedIn, userName }) => {
  const theme = useContext(ThemeContext);
  const componentClass = classNames(`welcome-container ${extraClasses}`, {
    'welcome-container--hidden': !isLoggedIn || isMobile,
  });

  return (
    <div aria-label="welcome text" className={componentClass} data-qa="welcome">
      hello&nbsp;
      <span
        aria-label="welcome user"
        className="welcome-container__text--capitalize"
      >
        {userName}
      </span>
      <style jsx>{`
        .welcome-container {
          text-align: center;
          color: ${theme.colors.headerprimary};
          font-size: 12px;
          text-transform: ${theme.text.transform};
        }
        .welcome-container--hidden {
          display: none;
        }

        .welcome-container__text--capitalize {
          text-transform: capitalize;
        }

        .margin-left-16 {
          margin-left: 16%;
        }

        @media (max-width: ${theme.breakpoints.mdDown}) {
          .margin-left-16 {
            margin-left: 0;
          }

          .welcome-container {
            margin-bottom: -3px;
          }
        }
      `}</style>
    </div>
  );
};

export default WelcomeText;

WelcomeText.propTypes = {
  extraClasses: PropTypes.string,
  isLoggedIn: PropTypes.bool,
  userName: PropTypes.string,
};
